(function () {
  'use strict';

  function findNavPrevLink() {
    return document.querySelector('.navigation.posts-navigation .nav-previous a');
  }

  function findNavContainer() {
    return document.querySelector('.navigation.posts-navigation');
  }

  function findPostsContainer() {
    return document.querySelector('.posts-container');
  }

  function resolveUrl(href) {
    try {
      return new URL(href, window.location.href).href;
    } catch (e) {
      return href;
    }
  }

  function setLoading(on) {
    var nav = findNavContainer();
    if (!nav) return;
    if (on) nav.classList.add('loading');
    else nav.classList.remove('loading');
  }

  function appendArticlesFromDocument(doc) {
    var newPostsContainer = doc.querySelector('.posts-container');
    var postsContainer = findPostsContainer();
    if (!postsContainer || !newPostsContainer) return 0;
    var articles = newPostsContainer.querySelectorAll('article');
    var count = 0;
    Array.prototype.forEach.call(articles, function (article) {
      // Clone the node from parsed doc into current document
      var clone = article.cloneNode(true);
      postsContainer.appendChild(clone);
      count++;
    });
    return count;
  }

  function updateNavLinkFromDocument(doc) {
    var newNavLink = doc.querySelector('.navigation.posts-navigation .nav-previous a');
    var currentNavLink = findNavPrevLink();
    var navContainer = findNavContainer();
    if (!navContainer) return;
    if (newNavLink && newNavLink.getAttribute('href')) {
      var href = resolveUrl(newNavLink.getAttribute('href'));
      if (currentNavLink) currentNavLink.setAttribute('href', href);
      // Há uma nova navegação disponível — permitir novas requisições
      canRequest = true;
    } else {
      // No next link -> remove navigation to end infinite scroll
      navContainer.parentNode && navContainer.parentNode.removeChild(navContainer);
      // Sem próxima página — bloquear requisições
      canRequest = false;
    }
  }

  function fetchNextPage(url, onComplete) {
    isLoading = true;
    setLoading(true);
    fetch(url, { credentials: 'same-origin' })
      .then(function (resp) {
        if (!resp.ok) throw new Error('Network response was not ok');
        return resp.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var appended = appendArticlesFromDocument(doc);
        updateNavLinkFromDocument(doc);
        if (typeof onComplete === 'function') onComplete(null, appended);
      })
      .catch(function (err) {
        if (typeof onComplete === 'function') onComplete(err);
      })
      .finally(function () {
        isLoading = false;
        lastRequestedUrl = null;
        setLoading(false);
      });
  }

  function onIntersect(entries, observer) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting || entry.intersectionRatio > 0) {
        // Bloqueios: só quando permitido, não carregando e não duplicando URL
        if (!canRequest || isLoading || lastRequestedUrl === resolvedHref) return;
        // Bloqueia novas requisições até que a navegação seja atualizada
        canRequest = false;

        var link = findNavPrevLink();
        if (!link) {
          observer.disconnect();
          return;
        }
        var href = link.getAttribute('href');
        if (!href) return;
        var resolvedHref = resolveUrl(href);

        // Marca esta URL como requisitada e pausa observação enquanto carrega
        lastRequestedUrl = resolvedHref;
        observer.unobserve(entry.target);
        fetchNextPage(resolvedHref, function (err, appended) {
          // If there is still a nav-link after update, observe again
          var navLink = findNavPrevLink();
          if (navLink) {
            try {
              observer.observe(navLink);
            } catch (e) {}
          }
        });
      }
    });
  }

  function startObserver() {
    var link = findNavPrevLink();
    if (!link) return;
    var options = { root: null, rootMargin: '0px 0px 10px 0px', threshold: 0 };
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(onIntersect, options);
      observer.observe(link);
    } else {
      // Fallback to scroll listener
      var onScroll = function () {
        if (isLoading) return;
        if (!canRequest) return;
        var rect = link.getBoundingClientRect();
        if (rect.top - window.innerHeight <= 10) {
          window.removeEventListener('scroll', onScroll);
          var href = link.getAttribute('href');
          if (!href) return;
          // Bloqueia novas requisições até que a navegação seja atualizada
          canRequest = false;
          fetchNextPage(resolveUrl(href), function () {
            var newLink = findNavPrevLink();
            if (newLink) window.addEventListener('scroll', onScroll);
          });
        }
      };
      window.addEventListener('scroll', onScroll);
      // run once in case already near
      onScroll();
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    var isLoading = false;
    var lastRequestedUrl = null;
    // Controle que impede novas requisições até que a navegação seja atualizada
    var canRequest = true;

    var link = findNavPrevLink();
    var posts = findPostsContainer();
    if (!link || !posts) return;
    startObserver();
  });
})();
